<modal-task [eventOpen]="openTaskModal.asObservable()" (reloadTasks)="getAllTasks()"></modal-task>

<button mat-raised-button color="primary" (click)="newTask()">
  <mat-icon>add</mat-icon> Nova Tarefa
</button>
<div>
  &nbsp;
</div>
<loader></loader>
<div class="row" *ngIf="resOk && tasks.length > 0">
  <div class="col-md-3" *ngFor="let task of tasks">

    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header border-0">
        <h3 class="card-title font-weight-bolder text-dark">{{task.taskType.name | translate}}</h3>
        <div class="card-toolbar">

          <button class="font-weight-bolder font-size-sm mr-3 cursor-pointer" mat-icon-button color="primary"
            (click)="editTask(task)" placement="top" ngbTooltip="Editar" ngbTooltipClass="kt-tooltip">
            <mat-icon>edit</mat-icon>
          </button>

          <button class="font-weight-bolder font-size-sm cursor-pointer" mat-icon-button color="accent"
            (click)="runTask(task)" placement="top" ngbTooltip="Executar agora" ngbTooltipClass="kt-tooltip">
            <mat-icon>play_arrow</mat-icon>
          </button>

          <!-- <button class="font-weight-bolder font-size-sm cursor-pointer" mat-icon-button placement="top"
            ngbTooltip="Histórico de execução" ngbTooltipClass="kt-tooltip">
            <mat-icon>history</mat-icon>
          </button> -->

        </div>
      </div>
      <div class="card-body pt-2">
        <div class="example-preview">
          <p><span class="font-weight-bolder text-dark-50 font-size-lg">Última Execução:</span> {{task.lastRun |
            date:'short'}}
          </p>
          <p> <span class="font-weight-bolder text-dark-50 font-size-lg">Frequência de Execução:</span>
            {{task.waitingHours}}h
          </p>
          <p class="font-weight-bolder text-dark-50 font-size-lg">
            Status:
            <span
              class="label label-lg label-inline {{ task.isActive == false ? 'label-light-danger' :'label-light-success'}}">
              {{task.isActive == true ? "Ativo":"Inativo"}}</span>
          </p>
        </div>
      </div>
    </div>

  </div>

</div>

<div class="row" *ngIf="resOk && tasks.length === 0">
  <mat-card>
    <p class="notData">Não existem dados a serem carregados!</p>
  </mat-card>
</div>
